import axios from "./axios";

export const uploadClientTokensFile = async (file, options = {}) => {
  const { signal } = options;
  const formData = new FormData();
  formData.append("client_data_file", file);
  const { data } = await axios.post("/api/users/upload-tokens/", formData, {
    signal,
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};
